import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SharedAuthenticationService } from '@arpes-is/angular-20-auth';

/** Pagina richiesta prima del login: CheckSession riporta sempre su `appEntryPoint`. */
export const RETURN_URL_KEY = 'novafito_return_url';

/**
 * Come IsLoggedInGuard di @arpes-is/angular-20-guards-interceptors: con il token scaduto ma la sessione
 * Keycloak ancora viva, `ensureSession()` rinnova il token invece di mandare al login.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(SharedAuthenticationService);
  const router = inject(Router);

  if (await auth.ensureSession()) {
    const returnUrl = readReturnUrl();
    if (returnUrl && returnUrl !== state.url) {
      return router.parseUrl(returnUrl);
    }
    return true;
  }

  try {
    sessionStorage.setItem(RETURN_URL_KEY, state.url);
  } catch {
    // Senza sessionStorage dopo il login si torna sulla pagina iniziale.
  }
  return router.parseUrl('/login');
};

function readReturnUrl(): string | null {
  try {
    const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);
    return returnUrl?.startsWith('/') && !returnUrl.startsWith('//') ? returnUrl : null;
  } catch {
    return null;
  }
}
